import { createFileRoute, redirect } from '@tanstack/react-router';

import { rutaInicialDe, useSesionStore } from '@/entities/usuario';
import { DashboardPage } from '@/pages/dashboard';

/**
 * El dashboard es para roles internos con alcance de portafolio. Los actores con
 * inicio propio no lo ven: el participante privado (PP) inicia en "Incidencias" y
 * el Supervisor en "Proyectos" (su alcance operativo). Este guard cubre todas las
 * entradas a `/dashboard` (login, `/`, navegación directa) y los redirige a su
 * ruta de inicio sin renderizar el dashboard (en `beforeLoad`, antes del montaje).
 */
export const Route = createFileRoute('/_private/dashboard')({
  beforeLoad: () => {
    const inicio = rutaInicialDe(useSesionStore.getState().user);
    if (inicio !== '/dashboard') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- patrón de redirect de TanStack Router
      throw redirect({ to: inicio });
    }
  },
  component: DashboardPage,
});
